import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["name", "id", "rows", "placeholder", "value", "disabled", "maxlength"]
const _hoisted_3 = {
  key: 1,
  class: "inline-flex items-center px-5 rounded-l-full border-r border-gray-900/[.04] bg-transparent text-gray-500 text-sm m-0"
}
const _hoisted_4 = { class: "relative w-full" }
const _hoisted_5 = ["type", "name", "id", "value", "disabled", "min", "max", "step", "oninput", "maxlength"]
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 2,
  class: "inline-flex items-center px-5 rounded-r-full border-l border-gray-900/[.04] bg-zinc-50 text-gray-500 text-sm m-0"
}
const _hoisted_8 = {
  key: 3,
  class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
}
const _hoisted_9 = {
  key: 1,
  class: "text-[10px] text-gray-600 mt-1"
}

import { ExclamationCircleIcon } from "@heroicons/vue/24/solid";
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    helper: {
        type: String,
        default: null,
    },
    error: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: null,
    },
    name: {
        type: String,
        default: null,
    },
    id: {
        type: String,
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    type: {
        type: String,
        default: "text",
    },
    textarea: {
        type: Boolean,
        default: false,
    },
    textAreaRows: {
        type: Number,
        default: 10,
    },
    oninput: {
        type: String,
        default: null,
    },
    add_on_right: {
        type: Boolean,
        default: false,
    },
    add_on_text: {
        type: String,
        default: null,
    },
    add_on_left: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    min: {
        type: Number,
        default: 0,
    },
    max: {
        type: Number,
    },
    step: {
        type: Number,
        default: 1,
    },
    maxlength: {
        type: Number,
    },
    showInputLimit: {
        type: Boolean,
        default: false,
    },
    customClass: {
        type: String,
        default: "",
    },
},
  setup(__props) {



const inputField = ref()
const focusInput = () => {
    inputField.value.focus();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["relative rounded-full bg-zinc-50 border border-gray-900/[.04]", [__props.add_on_right || __props.add_on_left ? 'flex' : '', __props.label ? 'mt-1' : '', __props.error ? 'border border-red-300' : '']])
    }, [
      (__props.textarea)
        ? (_openBlock(), _createElementBlock("textarea", {
            key: 0,
            name: __props.name,
            id: __props.id,
            rows: __props.textAreaRows,
            class: _normalizeClass(["block w-full pr-10 text-sm rounded-lg focus:outline-none focus:ring-0 disabled:bg-gray-100", 
                    __props.error
                        ? 'text-red-900 border-red-300 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'text-gray-800 border-gray-300 placeholder-gray-500 focus:border-gray-900'
                ]),
            placeholder: __props.placeholder,
            value: __props.modelValue,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            disabled: __props.disabled,
            maxlength: __props.maxlength
          }, null, 42, _hoisted_2))
        : _createCommentVNode("", true),
      (__props.add_on_left)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.add_on_text), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!__props.textarea)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              type: __props.type,
              name: __props.name,
              id: __props.id,
              ref_key: "inputField",
              ref: inputField,
              class: _normalizeClass(["block w-full h-12 px-5 pt-4 pb-1 text-sm border-0 frm-input disabled:bg-gray-100 focus:outline-none focus:ring-0 bg-zinc-50 peer", [
                        __props.customClass,
                        __props.error
                            ? 'rounded-full'
                            : __props.add_on_left
                            ? 'text-gray-800 border-gray-900/[.04] placeholder-gray-20 flex-1 min-w-0 block w-full px-3 py-2.5 rounded-none rounded-r-full focus:ring-gray-900 focus:border-primary-500 text-sm'
                            : __props.add_on_right
                            ? 'text-gray-800 border-gray-900/[.04] placeholder-gray-20 flex-1 min-w-0 block w-full px-3 py-2.5 rounded-none rounded-l-full focus:ring-gray-900 focus:border-primary-500 text-sm'
                            : 'text-gray-800 border-gray-900/[.04] placeholder-gray-20 focus:border-primary-500 rounded-full'
                    ]]),
              placeholder: " ",
              value: __props.modelValue,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
              disabled: __props.disabled,
              min: __props.min,
              max: __props.max,
              step: __props.step,
              oninput: __props.oninput,
              maxlength: __props.maxlength
            }, null, 42, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("label", {
          for: __props.id,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (focusInput())),
          class: "absolute duration-300 transform -translate-y-2.5 top-3.5 left-5 scale-[.60] origin-[0] text-sm text-gray-20 cursor-text peer-focus:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-[.60] peer-focus:-translate-y-2.5"
        }, _toDisplayString(__props.placeholder), 9, _hoisted_6)
      ]),
      _renderSlot(_ctx.$slots, "password"),
      (__props.add_on_right)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.add_on_text), 1))
        : _createCommentVNode("", true),
      (__props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_unref(ExclamationCircleIcon), {
              class: "w-5 h-5 text-red-500",
              "aria-hidden": "true"
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.showInputLimit)
      ? (_openBlock(), _createElementBlock("small", {
          key: 0,
          class: _normalizeClass(["block mt-1 text-right", [
                __props.modelValue.length >= __props.maxlength
                    ? 'text-red-600'
                    : 'text-darkgray-400',
            ]])
        }, _toDisplayString(__props.modelValue.length) + "/" + _toDisplayString(__props.maxlength), 3))
      : _createCommentVNode("", true),
    (__props.helper)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.helper), 1))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})